import React, { Fragment, useState, useEffect } from 'react'
import './Sales.css'
import { useSelector, useDispatch } from 'react-redux'
import { Tab, Tabs, Typography, Stack, Box } from '@mui/material'
import PropTypes, { InferProps } from 'prop-types'
import ContactWorldSellers from './ContactWorldSellers'
import ContactUsSellers from './ContactUsSellers'
import Countries from '../../components/Sales/Countries'
import USStates from '../../components/Sales/USStates'
import { FormattedMessage, useIntl } from 'react-intl'
import { getCountries } from '../../actions'
import { IReducer } from '../../interface'
import SeoSales from '../../components/seo/SeoSales'
import { useCookies } from 'react-cookie'
import BgImageTitleLayout from '../../components/Common/BgImageTitleLayout'
import { TabsBox } from '../../styles'
import { getSellersGQL } from 'src/services/graphql/schemas/sellers'

function TabPanel(props: InferProps<typeof TabPanel.propTypes>) {
  const { children, value, index, ...other } = props

  return (
    <Typography
      component='div'
      role='tabpanel'
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && <Fragment>{children}</Fragment>}
    </Typography>
  )
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired
}

export default function Sales() {
  const dispatch = useDispatch()
  const intl = useIntl()

  const dataContactReducer: any = useSelector((state: IReducer) => state.dataContactReducer)
  const dataCountriesReducer: any = useSelector((state: IReducer) => state.dataCountriesReducer)
  const [cookies] = useCookies(['country_code'])

  const [value, setValue] = useState(0)
  const [countrySelected, setCountrySelected] = useState('SelectCountry')
  const [americaStateSelected, setAmericaStateSelected] = useState('SelectState')
  const [americaStates, setStates] = useState(new Set<string>())

  const setStatesList = () => {
    if (dataContactReducer.dealersAgents.domestic.length > 0 && americaStates.size === 0) {
      let states: Array<string> = []
      for (const iterator of dataContactReducer.dealersAgents.domestic) {
        states = states.concat(iterator.states)
      }
      setStates(new Set<string>(states))
    }
  }

  useEffect(() => {
    if (!dataContactReducer.dealersAgents.domestic.length && !dataContactReducer.dealersAgents.dealers.length) {
      dispatch(getSellersGQL())
    } else {
      setStatesList()
    }

    if (dataCountriesReducer.countries.length === 0) {
      dispatch(getCountries())
    }

    if (cookies.country_code !== 'us') setValue(1)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    setValue(cookies.country_code === 'us' ? 0 : 1)
  }, [cookies.country_code])

  useEffect(() => {
    setStatesList()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataContactReducer.dealersAgents.domestic.length])

  const countryItems = dataContactReducer.dealersAgents.dealers.filter((item: any) => {
    return item.Country === countrySelected
  })
  const usStateItem = dataContactReducer.dealersAgents.domestic.find((item: any) => {
    return item.states.findIndex((state: string) => americaStateSelected === state) > -1
  })

  return (
    <Box data-cy='sales-container'>
      <SeoSales
        title={intl.formatMessage({ id: 'seo.sales.title' })}
        description={intl.formatMessage({ id: 'seo.sales.description' })}
      />
      <BgImageTitleLayout
        title='sales.title'
        description='sales.description'
        bgImage='url(https://meteor.stullercloud.com/das/138561875)'
      >
        <TabsBox sx={{ bgcolor: 'transparent !important' }}>
          <Tabs value={value} onChange={(_, newValue) => setValue(newValue)}>
            <Tab
              disableRipple={true}
              label={<FormattedMessage id='nav.northAmerica' />}
              value={0}
              data-cy='US-button'
            />
            <Tab
              disableRipple={true}
              label={<FormattedMessage id='nav.international' />}
              value={1}
              data-cy='international-button'
            />
          </Tabs>
        </TabsBox>
        <TabPanel value={value} index={0} key={'SalesRepTab'}>
          <div className='sales-combo-wrapper'>
            <USStates
              EEUUStates={americaStates}
              americaStateSelected={americaStateSelected}
              setAmericaStateSelected={setAmericaStateSelected}
            />
          </div>
          {usStateItem && <ContactUsSellers key='salesRepItem' {...usStateItem} />}
          {americaStateSelected === 'SelectState' && (
            <Typography>
              <FormattedMessage id='sales.selectYourStateTo' />
            </Typography>
          )}
        </TabPanel>
        <TabPanel value={value} index={1} key={'DealersTab'}>
          <div className='sales-combo-wrapper'>
            <Countries
              countrySelected={countrySelected}
              setCountrySelected={setCountrySelected}
              countries={dataCountriesReducer.countries}
            />
          </div>
          <Stack spacing={2}>
            {countryItems.map((countryItem: any) => (
              <ContactWorldSellers key={countryItem} {...countryItem} />
            ))}
            {countrySelected === 'SelectCountry' ? (
              <Typography>
                <FormattedMessage id='sales.selectYourCountryTo' />
              </Typography>
            ) : (
              <ContactWorldSellers
                ImageUrl='https://gemvision.com/Images/dynamic/salesrep/Chris.png'
                ImageAlt='Chris Burger - International Sales Rep'
                Contact='Chris Burger'
                Email='chris_burger@gemvision.com'
                PhoneNumber='800.357.6272 x5327'
              />
            )}
          </Stack>
        </TabPanel>
      </BgImageTitleLayout>
    </Box>
  )
}
